import gql from 'graphql-tag';

export const _GET_NOTES = gql`
	query risolto_notes($participant: uuid, $recipientRef: uuid, $limit: Int = 10, $offset: Int = 0) {
		total: risolto_note_aggregate(
			order_by: { created_at: desc }
			where: { recipient: { _eq: $recipientRef }, participant: { _eq: $participant } }
			limit: $limit
			offset: $offset
		) {
			aggregate {
				count
			}
		}
		notes: risolto_note(
			order_by: { created_at: desc }
			where: { recipient: { _eq: $recipientRef }, participant: { _eq: $participant } }
			limit: $limit
			offset: $offset
		) {
			reference
			note
			created_by
			created_at
			person_by_reference {
				reference
				external_id
				username
			}
			note_invoices {
				reference
				invoice_by_reference {
					reference
					invoice_number
				}
			}
		}
	}
`;

export const _GET_INVOICE_NOTES = gql`
	query getInvoiceNotes($participant: uuid!, $invoice: uuid!, $limit: Int = 10, $offset: Int = 0) {
		notes: risolto_note_invoice(
			where: { _and: [{ invoice: { _eq: $invoice } }, { participant: { _eq: $participant } }] }
			limit: $limit
			offset: $offset
			order_by: { note_by_reference: { created_at: desc } }
		) {
			note
			note_by_reference {
				reference
				note
				created_at
				created_by
				person_by_reference {
					reference
					external_id
					username
				}
			}
		}
		total: risolto_note_invoice_aggregate(
			where: { _and: [{ invoice: { _eq: $invoice } }, { participant: { _eq: $participant } }] }
			limit: $limit
			offset: $offset
		) {
			aggregate {
				count
			}
		}
	}
`;

export const _INSERT_NOTE = gql`
	mutation insert_risolto_note(
		$note: String!
		$category: risolto_note_category_enum
		$participant: uuid!
		$invoice: uuid
		$recipient: uuid!
		$legal_entity: uuid!
		$created_by: uuid!
		$action: uuid
	) {
		result: insert_risolto_note(
			objects: {
				note: $note
				participant: $participant
				category: $category
				recipient: $recipient
				legal_entity: $legal_entity
				created_by: $created_by
				invoice_document: $invoice
				action: $action
			}
		) {
			updated_count: affected_rows
			returning {
				reference
				note
			}
		}
	}
`;

export const _INSERT_INVOICE_NOTE = gql`
	mutation insertInvoiceNote($note: uuid!, $invoice: uuid!, $participant: uuid!, $legalEntity: uuid!) {
		insert_risolto_note_invoice(objects: { invoice: $invoice, note: $note, legal_entity: $legalEntity, participant: $participant }) {
			affected_rows
			returning {
				reference
			}
		}
	}
`;

export const _UPDATE_NOTE = gql`
	mutation update_risolto_note($noteRef: uuid!, $newNote: String!) {
		update_risolto_note(where: { reference: { _eq: $noteRef } }, _set: { note: $newNote }) {
			updated_count: affected_rows
			updated: returning {
				note
				reference
			}
		}
	}
`;

export const _DELETE_NOTE = gql`
	mutation delete_risolto_note($noteRef: uuid!) {
		delete_risolto_note(where: { reference: { _eq: $noteRef } }) {
			deleted: affected_rows
		}
	}
`;

export const _DELETE_NOTE_INVOICE = gql`
	mutation deleteInvoiceNote($note: uuid!) {
		delete_risolto_note_invoice(where: { note: { _eq: $note } }) {
			returning {
				reference
			}
			affected_rows
		}
		delete_risolto_note(where: { reference: { _eq: $note } }) {
			returning {
				reference
			}
			affected_rows
		}
	}
`;
